<template>
  <method-config-component
    :search-params="searchParams"
    :config-name-list="configNameList"
  />
</template>

<script>
import MethodConfigComponent from '../components/methodConfigComponent.vue'
export default {
  components: { MethodConfigComponent },
  data() {
    return {
      searchParams: {
        type: 1
      },
      configNameList: [
        'CASH_PAYMENT',
        'OTHER',
        'CREDIT_CARD_PAYMENT',
        'TRANSFER_PAYMENT',
        'DEBT_PAYMENT_HOTEL',
        'PREPAID_CARD_PAYMENT'
      ]
    }
  }
}
</script>
